<template>
  <section class="crm-layer">
    <div :class="['mask-layer', isClase ? 'show' : 'hide']"></div>
    <div class="crm-body" v-show="isClase">
      <div class="wrapper">
        <img
          class="logo"
          v-lazy="require(`@/assets/images/home/crm-back.png`)"
        />
        <h2 v-if="messageBody.title">{{ messageBody.title }}</h2>
        <div class="content" v-if="messageBody.content">
          {{ messageBody.content }}
        </div>
        <div
          v-if="messageBody.buttonName"
          class="wrapper-btn"
          @click="handleJump"
        >
          {{ messageBody.buttonName }}
        </div>
      </div>

      <div class="close-icon" @click="handleClose">
        <img :src="require(`@/assets/images/home/crm-close.png`)" />
      </div>
    </div>
  </section>
</template>

<script>
  import { getCrmWindow } from '@/api/crm'
  import { isJsonString } from '@/utils/tool'
  import { mapState } from 'vuex'
  import { PQ, Message } from '@/utils/priorityQueue'
  import { jumpToPage } from '@/utils/utils'

  const popup_id = 'crm-popup'

  export default {
    props: {
      pageType: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        isClase: false,
        messageBody: {
          //映射接口字段
          title: '',
          content: '',
          buttonName: '',
          jumpUrl: '',
        },
      }
    },
    computed: {
      ...mapState(['userInfo']),
    },
    mounted() {
      Message.receive((res) => {
        const { id } = res || {}
        if (id === popup_id) {
          this.isClase = true
          PQ.open(popup_id)
        }
      })
    },

    destroyed() {
      PQ.close(popup_id)
    },
    watch: {
      userInfo: {
        handler(newVal) {
          if (newVal === null) return
          this.getLayerData(newVal)
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      async getLayerData({ kicoinId = '' }) {
        try {
          const params = {
            kicoinId,
            pageType: this.pageType,
          }
          const result = await getCrmWindow(params)

          if (result.messageType !== 6) return

          if (result.messageBody && isJsonString(result.messageBody)) {
            const { content = '', buttonName = '' } = JSON.parse(
              result.messageBody
            )

            this.messageBody = {
              content,
              buttonName,
            }
          }

          this.messageBody.title = result?.messageTitle || ''
          this.messageBody.jumpUrl = result?.jumpUrl || ''

          PQ.enqueue({
            id: popup_id,
            priority: 7,
          })
        } catch (error) {
          window.console.warn('%c[__getLayerData]方法报错', 'color:#0f0', error)
        }
      },
      handleJump() {
        if (this.messageBody.jumpUrl.trim() === '') return
        jumpToPage(this.messageBody.jumpUrl, 'open')
      },
      handleClose() {
        this.isClase = false
        PQ.close(popup_id)
      },
    },
  }
</script>

<style scoped lang="scss" src="./styles.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
